let lastId = 0;

export default function(prefix = 'uniId_') {
  lastId++;
  return `${prefix}${lastId}`;
}



// WEBPACK FOOTER //
// ./src/__utils/idGenerator.js